import TriggerType from './TriggerType';

const TriggerStatus = {
  FOUND: 'FOUND',
  REASSESSED: 'REASSESSED',
  REMEDIATED: 'REMEDIATED',
  UPDATED: 'UPDATED',
};

Object.freeze(TriggerStatus);
export default TriggerStatus;

export const TRIGGER_STATUSES_BY_TRIGGER_TYPE = {
  [TriggerType.ASSET]: [TriggerStatus.FOUND],
  [TriggerType.VULNERABILITY]: [TriggerStatus.FOUND, TriggerStatus.REASSESSED],
};
Object.freeze(TRIGGER_STATUSES_BY_TRIGGER_TYPE);
